import { HttpClient } from '../../httpClient'

export interface CreateNoteRequestBody {
  note: {
    comment: string
  }
}

interface CreateNoteResponseData {
  id: number
  user_id: number
  comment: string
  asset_references_count: number
  last_editor: number | null
  created_at: string
  updated_at: string
  asset_references: unknown[]
}

export interface CreateNoteParams {
  workspaceSlug: string
  momentId: string
}

export interface CreateNoteRequestArgs {
  params: CreateNoteParams
  requestBody: CreateNoteRequestBody
}

export function createNote({
  params,
  requestBody,
}: CreateNoteRequestArgs): Promise<CreateNoteResponseData> {
  const url = new URL(
    `/moments/${params.workspaceSlug}/${params.momentId}/note`,
    window.location.origin
  )

  return HttpClient()
    .post<CreateNoteResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
